import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import keydown from 'react-keydown';
import { Paper, DialogContent as MUIDialogContent } from '@material-ui/core';
import { get as loget } from 'lodash';

import { SolutionDetails as SolutionDetailsView } from '../../../../Components/MockExam';
import fillArray from '../../../../Util/fillArray';

import SolutionToolbar from './SolutionToolbar';

export const DialogContent = styled(({ borderless, ...restProps }) => (
  <MUIDialogContent {...restProps} />
))`
  ${props =>
    props.borderless &&
    css`
      &&& {
        padding: 0;
      }
    `};
`;

const getAnswer = (answers = [], referenceId) =>
  answers.find(answer => answer.referenceId === referenceId);

const parseGATQuestions = (gatQuestion, gatAnswer, answerSlot = 4) => ({
  id: gatQuestion.id,
  label: gatQuestion.itemNumber,
  title: gatQuestion.title,
  answer: fillArray(loget(gatAnswer, 'answer.arrayValue', []), answerSlot, ''),
  result: loget(gatAnswer, 'answerAttributes.value', []).map(c => c === 'CORRECT'),
  solution: fillArray(loget(gatQuestion, 'answer.arrayValue', []), answerSlot, ''),
  score: loget(gatAnswer, 'score'),
  maxScore: gatQuestion.fullScore,
});

const getGATTable = (questions = [], allAnswers = []) => {
  const maxAnswerSlot = questions.reduce((max, b) => {
    const bLength = loget(b, 'answer.arrayValue', []).length;
    return bLength > max ? bLength : max;
  }, 4);
  return questions.map(question => {
    const answer = getAnswer(allAnswers, question.referenceId);
    const gatrow = parseGATQuestions(question, answer, maxAnswerSlot);
    return gatrow;
  });
};
class SolutionDetails extends Component {
  static propTypes = {
    onBackClick: PropTypes.func,
    onNextClick: PropTypes.func,
    onPreviousClick: PropTypes.func,
  };

  static defaultProps = {
    onBackClick: () => {},
    onNextClick: () => {},
    onPreviousClick: () => {},
  };

  handleKeyPress = (code, isFirstQuestion, isLastQuestion) => {
    if (code === 'ArrowRight' && !isLastQuestion) {
      this.props.onNextClick();
    } else if (code === 'ArrowLeft' && !isFirstQuestion) {
      this.props.onPreviousClick();
    }
  };

  handleNavigateByKeyPress = event => {
    if (event === null) return;
    const { navigationValue } = this.props;
    const { isFirstQuestion, isLastQuestion } = navigationValue;
    this.handleKeyPress(event.code, isFirstQuestion, isLastQuestion);
  };

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.keydown.event && prevProps.keydown.event) {
      const { event } = prevProps.keydown;
      this.handleNavigateByKeyPress(event);
    }
  }

  render() {
    const {
      onBackClick,
      onNextClick,
      onPreviousClick,
      currentQuestion,
      allAnswers,
      currentAssets,
      currentSection,
      title,
      navigationValue,
    } = this.props;
    // console.log(currentQuestion, allAnswers, currentAssets);
    const {
      sectionIndex,
      itemNumber,
      totalQuestionsInSection,
      isFirstQuestion,
      isLastQuestion,
    } = navigationValue;

    const { solutionVideo, solutionImages = [] } = currentAssets;
    const isGAT = currentQuestion.type === 'TOPIC';
    const imagesArray = (solutionImages || []).map(image => image.url);
    let items = [];
    let secondaryItems = [];
    let secondaryTitle = null;
    let gatAnswers = [];
    let candidateAnswer = null;
    let isCorrect = null;

    if (isGAT && imagesArray.length > 1) {
      items.push(imagesArray[1]);
      secondaryItems.push(imagesArray[0]);
      secondaryTitle = currentQuestion.title;
    } else {
      items = imagesArray;
    }

    if (isGAT) {
      gatAnswers = getGATTable(currentQuestion.subQuestions, allAnswers);
    } else {
      const answer = getAnswer(allAnswers, currentQuestion.referenceId);
      // console.log(answer);
      candidateAnswer = loget(answer, 'answer.singleValue', null);
      isCorrect = loget(answer, 'isCorrect', null);
    }

    return (
      <Fragment>
        <SolutionToolbar
          onBackClick={onBackClick}
          onNextClick={onNextClick}
          onPreviousClick={onPreviousClick}
          disablePreviousButton={isFirstQuestion}
          disableNextButton={isLastQuestion}
          onNavigateKeyPressed={this.handleNavigateByKeyPress}
        />
        <Paper elevation={24}>
          <DialogContent borderless>
            <SolutionDetailsView
              title={title}
              onBackClick={onBackClick}
              isGAT={isGAT}
              video={solutionVideo ? { src: solutionVideo.url, type: 'video/youtube' } : undefined}
              items={items}
              secondaryItems={secondaryItems}
              secondaryTitle={secondaryTitle}
              question={{
                current: itemNumber,
                total: totalQuestionsInSection,
              }}
              gatAnswers={gatAnswers}
              candidateAnswer={candidateAnswer}
              correct={isCorrect}
            />
          </DialogContent>
        </Paper>
      </Fragment>
    );
  }
}

export default keydown('left', 'right')(SolutionDetails);
